import { Feature } from '@/featureflag_manager';
import { RouteNames } from '@/types/routes';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: RouteNames.FINETUNE_HOME,
    path: 'fine-tune',
    redirect: { name: RouteNames.FINETUNE },
    meta: {
      feature_flag: Feature.FINETUNING,
    },
    children: [
      {
        name: RouteNames.FINETUNE,
        path: '',
        components: {
          default: () => import('@/modules/Finetune/views/ViewFineTune.vue'),
        },
      },
    ],
  },
];
export default routes;
